import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight, FileText, BarChart, CreditCard, Shield } from 'lucide-react';

const Guides = () => {
  const guideTopics = [
    { icon: FileText, title: 'Comment Parier en Ligne', color: 'text-blue-400' },
    { icon: BarChart, title: 'Comprendre les Cotes', color: 'text-green-400' },
    { icon: CreditCard, title: 'Méthodes de Paiement', color: 'text-purple-400' },
    { icon: Shield, title: 'Sécurité et Licences', color: 'text-yellow-400' },
  ];

  return (
    <section id="guides" className="py-20 bg-gray-800">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              <span className="bg-gradient-to-r from-pink-400 to-pink-600 bg-clip-text text-transparent">
                Guides Pratiques
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Tout ce qu'il faut savoir pour parier en ligne en France en toute sécurité
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 md:p-12 border border-pink-500/20 mb-8">
            <div className="flex items-start space-x-4 mb-6">
              <div className="w-12 h-12 bg-pink-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <BookOpen className="text-white" size={24} />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Comment Parier en Ligne en France : Guide Complet
                </h3>
                <p className="text-gray-300 leading-relaxed mb-4">
                  Parier en ligne en France nécessite de choisir un opérateur agréé par l'Autorité Nationale des Jeux (ANJ). Après avoir sélectionné un site fiable, créez un compte en fournissant vos informations d'identité vérifiées, effectuez un dépôt sécurisé via les méthodes acceptées (carte bancaire, virement, portefeuille électronique), puis profitez des bonus de bienvenue pour maximiser votre bankroll initial.
                </p>
                <p className="text-gray-300 leading-relaxed mb-6">
                  Pour parier efficacement, familiarisez-vous avec les différents types de paris (simple, combiné, système), apprenez à lire les cotes et gérer votre bankroll. Les sites agréés offrent des outils de jeu responsable, des limites de dépôt personnalisables et un support client disponible pour vous accompagner. Chaque pari doit être réfléchi et basé sur une analyse solide, pas sur l'émotion.
                </p>
                <Link
                  to="/guides"
                  data-discover="true"
                  className="inline-flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-pink-600 to-pink-700 text-white rounded-lg font-semibold hover:from-pink-700 hover:to-pink-800 transition-all group"
                >
                  <span>Accéder à tous les guides</span>
                  <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {guideTopics.map((topic, index) => {
              const Icon = topic.icon;
              return (
                <Link
                  key={index}
                  to="/guides"
                  data-discover="true"
                  className="bg-gray-900 rounded-xl p-6 border border-gray-700 hover:border-pink-600 transition-all transform hover:-translate-y-1 text-center"
                >
                  <Icon className={`${topic.color} mx-auto mb-3`} size={32} />
                  <h4 className="text-white font-semibold text-sm">{topic.title}</h4>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guides;

